import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from "src/app/services/auth/auth.service";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  FormResetPassword: FormGroup;
  loading = false;
  submitForgotPassword = false;
  code = "";
  path = "";
  constructor(
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {
    this.FormResetPassword = this.formBuilder.group(
      {
        code: [""],
        password: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
      },
      { validators: this.checkPasswords }
    );
  }
  // convenience getter for easy access to form fields
  get resetPassword() {
    return this.FormResetPassword.controls;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  checkPasswords(group: any) {
    // here we have the 'passwords' group
    const password = group.get("password").value;
    const confirmPassword = group.get("confirmPassword").value;
    return password === confirmPassword ? null : { notSame: true };
  }

  onSubmit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.code = params.code;
      this.submitForgotPassword = true;
      if (this.FormResetPassword.invalid) {
        if (this.FormResetPassword.invalid) {
          Webflow.setIFrameHeight();
          if (this.FormResetPassword.controls["password"].errors?.required) {
            Swal.fire({
              title: "Erreur",
              text: 'Le champ "Mot de passe" est requis',
              icon: "error",
              position: "top",
            });
          } else if (
            this.FormResetPassword.controls["password"].errors?.minlength
          ) {
            Swal.fire({
              title: "Erreur",
              text: "Le mot de passe doit contenir au moins 6 caractères",
              icon: "error",
              position: "top",
            });
          } else if (
            this.FormResetPassword.controls["confirmPassword"].errors?.required
          ) {
            Swal.fire({
              title: "Erreur",
              text: 'Le champ "Confirmez votre mot de passe" est requis',
              icon: "error",
              position: "top",
            });
          } else if (
            this.FormResetPassword.value.password !==
            this.FormResetPassword.value.confirmPassword
          ) {
            Swal.fire({
              title: "Erreur",
              text: "Les mots de passe ne correspondent pas",
              icon: "error",
              position: "top",
            });
          } else {
            Swal.fire({
              title: "Erreur",
              text: "Veuillez vérifier vos informations",
              icon: "error",
              position: "top",
            });
          }
          return;
        }
      }
      this.spinner.show();
      this.authenticationService
        .resetPassword(
          this.code,
          this.FormResetPassword.value.password,
          this.FormResetPassword.value.confirmPassword
        )
        .subscribe(
          (data) => {
            Webflow.setIFrameHeight();
            this.FormResetPassword.reset();
            Swal.fire({
              title: "Félicitation",
              text: "Votre mot de passe a été changé avec succès",
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "Se connecter",
              cancelButtonText: "fermer",
              position: "top",
              cancelButtonColor: "black",
              confirmButtonColor: "#D63333",
            }).then((result) => {
              if (result.isConfirmed) {
                Webflow.myAction(this.router, "login", {});
              }
            });
          },
          (error) => {
            Webflow.setIFrameHeight();

            if (GenerateErrors.check_if_is_custom_error(error)) {
              Swal.fire({
                title: "Erreur",
                text: GenerateErrors.get_message_error(error),
                icon: "error",
                position: "top",
              });
            } else {
              Swal.fire({
                title: "Erreur",
                text: "Une érreur est survenue",
                icon: "error",
                position: "top",
              });
            }
          }
        )
        .add(() => {
          this.spinner.hide();
        });
    });
  }

  navigateTo(actionName: string) {
    Webflow.myAction(this.router, actionName, {});
  }
}
